import { isI18nLocaleRoute, parseLocaleFromPath } from "~/utils/i18n-locale-routes";

/** UI locale → API Lang 请求头 */
export const LOCALE_TO_API_LANG = {
	"zh-TW": "zh_TW",
	en: "en_US",
};

const DEFAULT_API_LANG = "zh_TW";
const APP_LANG_STORAGE_KEY = "app_lang";
const I18N_LANG_STORAGE_KEY = "app-language";

export function localeToApiLang(locale) {
	return LOCALE_TO_API_LANG[locale] || DEFAULT_API_LANG;
}

/**
 * 解析 API 请求的 Lang 请求头
 * 优先级：运行时 locale（vue-i18n）> App 内嵌（app_lang）> 用户语言偏好 > 默认 zh_TW
 *
 * @param {string} [path] 当前路由 path（保留参数，便于按路由扩展）
 * @param {{ i18nLocale?: string | null }} [options] 客户端传 vue-i18n locale；SSR 传 cookie
 */
export function resolveRequestLang(path, options = {}) {
	const { i18nLocale: runtimeLocale } = options;

	if (runtimeLocale && LOCALE_TO_API_LANG[runtimeLocale]) {
		return localeToApiLang(runtimeLocale);
	}

	if (import.meta.client && typeof window !== "undefined" && window.localStorage) {
		const appLang = localStorage.getItem(APP_LANG_STORAGE_KEY);
		if (appLang) return appLang;
	}

	let i18nLocale = runtimeLocale ?? null;
	if (!i18nLocale && import.meta.client && typeof window !== "undefined" && window.localStorage) {
		i18nLocale = localStorage.getItem(I18N_LANG_STORAGE_KEY);
	}

	if (i18nLocale && LOCALE_TO_API_LANG[i18nLocale]) {
		return localeToApiLang(i18nLocale);
	}

	// 非多语言路由仍默认 zh_TW（兼容未接入 i18n 的旧页面）
	const pathname =
		path ?? (import.meta.client && typeof window !== "undefined" ? window.location.pathname : "");

	if (pathname && !isI18nLocaleRoute(pathname)) {
		return DEFAULT_API_LANG;
	}

	const fromPath = pathname ? parseLocaleFromPath(pathname) : null;
	if (fromPath) {
		return localeToApiLang(fromPath);
	}

	return DEFAULT_API_LANG;
}

/**
 * 生成带多语言请求头的 axios config
 * @param {string} [locale] vue-i18n locale，如 zh-TW | en
 */
export function createLangRequestConfig(locale) {
	const apiLang = locale ? localeToApiLang(locale) : DEFAULT_API_LANG;

	return {
		headers: {
			Lang: apiLang,
		},
	};
}
